import { Wedding, WeddingDatePeriod } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const getAllEventPlannerWeddings = generateAPI<
  {
    query: Partial<{
      page: number;
      limit: number;
      search: string;
      weddingDatePeriod: WeddingDatePeriod;
    }>;
  },
  {
    weddingCount: number;
    weddingList: Wedding[];
  }
>("get", "wedding/event-planner/all");
